import { Injectable } from '@angular/core';
import { Params } from '../models/params.model';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { timeout, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { SsrCookieService } from 'ngx-cookie-service-ssr';


@Injectable({
  providedIn: 'root'
})
export class AppParamsService {

  private params: Params;
  private entryUrl: string;
  private userIp: string;

  constructor(
    private http: HttpClient,
    private cookieService: SsrCookieService
  ) {
    this.params = new Params();
    this.entryUrl = "";
    this.userIp = ""
  }

  async setParams(params: object) {

    const auxParameters: any = { ...params };
    // fill params object
    this.params.setUtmSource(auxParameters.utm_source ? auxParameters.utm_source : '418761');
    delete auxParameters.utm_source;

    if (auxParameters.SID) {
      this.params.setSid(auxParameters.SID);
      delete auxParameters.SID;
    } else if (auxParameters.sid) {
      this.params.setSid(auxParameters.sid);
      delete auxParameters.sid;
    } else {
      this.params.setSid('unassigned');
    }

    this.params.setCampaignId(environment.cid);
    this.params.setAdditionalParams(auxParameters);

    this.userIp = this.userIp ? this.userIp : await this.getPublicIp() as string;
    this.params.setPublicIp(this.userIp);
  }


  async getPublicIp() {

    const promise = new Promise((resolve, reject) => {
      this.http.get('https://api.ipify.org?format=json')
        .pipe(
          timeout(2000),
          catchError(e => {
            console.error('IP timeout');
            resolve('IP_ERROR');
            return of('IP_ERROR');
          })
        ).subscribe((data: any) => {
          resolve(data['ip']);
        }, (err: any) => {
          console.log(err);
          resolve('IP_ERROR');
        });
    });

    return promise.then(data => {
      return data;
    }).catch(err => {
      return err;
    });

  }

  setEntryUrl(entryUrl: string) {
    this.entryUrl = entryUrl;
  }

  getEntryUrl() {
    return this.entryUrl;
  }

  getParams() {
    return this.params;
  }



  public getGACookie() {
    var allCookies = this.cookieService.getAll();

    if (allCookies.hasOwnProperty("_ga")) {
      return allCookies["_ga"].replace(/GA1.[0-9]*./, '');
    } else {
      return "n";
    }
  }

  public getGASessionIdCookie() {
    var allCookies = this.cookieService.getAll();
    var gaSessionId = "";
    Object.keys(allCookies).forEach((key) => {
      if (key.includes('_ga_')) {
        var array = allCookies[key].split(".");
        gaSessionId = array[2];
      }
    });
    return gaSessionId
  }


  public getGASessionIdNumberCookie() {
    var allCookies = this.cookieService.getAll();
    var gaSessioIdNumber = "";
    Object.keys(allCookies).forEach((key) => {
      if (key.includes('_ga_')) {
        var array = allCookies[key].split(".");
        gaSessioIdNumber = array[3];
      }
    });
    return gaSessioIdNumber
  }

  public getFbpCookie() {
    var allCookies = this.cookieService.getAll();
    return allCookies['_fbp'] || "";
  }

}
